import React from "react";

interface SectionHeaderProps {
  number: string;
  title: string;
  highlight?: string;
  subtitle?: string;
  centered?: boolean;
}

const SectionHeader = ({ number, title, highlight, subtitle, centered = true }: SectionHeaderProps) => {
  return (
    <div className={`mb-12 md:mb-16 ${centered ? 'text-center' : ''}`}>
      {/* Title with inline number */}
      <div className={`flex items-center gap-4 mb-4 flex-wrap ${centered ? 'justify-center' : ''}`}>
        <span className="text-4xl md:text-5xl font-black text-primary/20 font-mono">
          {number}
        </span>
        <div className="h-px w-8 bg-primary/30 hidden sm:block" />
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-foreground tracking-tight">
          {title}{" "}
          {highlight && (
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              {highlight}
            </span>
          )}
        </h2>
      </div>
      
      {/* Subtitle */}
      {subtitle && (
        <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
